import React from "react";
import { ReactComponent as DeliveryIcon } from "icons/deliveryIcon.svg";
import { ReactComponent as BlockIcon } from "icons/blockIcon.svg";
import { ReactComponent as TemperatureIcon } from "icons/temperatureIcon.svg";
import { List, ListItem, Typography } from "@material-ui/core";
import { eventDescriptionStyles } from "./EventDescriptionStyles";
import { observer } from "mobx-react";
import { useStore } from "store/StoreConfigs";
import { numberAfterDotCounter } from "helpers/numberAfterDotCounter";
import { pluralize } from "helpers/pluralize";

export default observer(function EventDescription() {
    const classes = eventDescriptionStyles();
    const { thorEventViewStore } = useStore();
    return (
        <div className={classes.main}>
            <Typography className={classes.title}>Description</Typography>
            <Typography className={classes.subTitle}>
                Considerations & Context to help you when making your assessment.
            </Typography>
            <List className={classes.gridContainer}>
                <ListItem>
                    <TemperatureIcon />
                    <Typography className={classes.text}>
                        During transportation, the temperature range was between{" "}
                        {numberAfterDotCounter(thorEventViewStore.eventDetails.minTemperature)}
                        °C and {numberAfterDotCounter(thorEventViewStore.eventDetails.maxTemperature)}
                        °C. The temperature was outside of the required transportation range for{" "}
                        <span style={{ fontWeight: 600 }}>
                            {numberAfterDotCounter(thorEventViewStore.eventDetails.durationInHours)}{" "}
                            {pluralize("hour", numberAfterDotCounter(thorEventViewStore.eventDetails.durationInHours))}.
                        </span>
                    </Typography>
                </ListItem>
                <ListItem>
                    <BlockIcon />
                    <Typography className={classes.text}>
                        The {pluralize("batch", thorEventViewStore.eventDetails.impactedBatches.length)}
                        {thorEventViewStore.eventDetails.impactedBatches.map((batch, index) => (
                            <span className={classes.linkText} key={batch.batchId}>
                                {" "}
                                #{batch.batchNumber}{" "}
                                {index !== thorEventViewStore.eventDetails.impactedBatches.length - 1 && ","}
                            </span>
                        ))}
                        {thorEventViewStore.eventDetails.impactedBatches.length === 1 ? "requires" : "require"} impact
                        assessment.
                    </Typography>
                </ListItem>
                <ListItem>
                    <DeliveryIcon />
                    <Typography className={classes.text}>
                        {pluralize("Order", thorEventViewStore.eventDetails.impactedOrders.length)}{" "}
                        {thorEventViewStore.eventDetails.impactedOrders.map((order, index) => (
                            <span className={classes.linkText} key={order.orderId}>
                                {" "}
                                #{order.orderNumber}
                                {index !== thorEventViewStore.eventDetails.impactedOrders.length - 1 && ","}
                            </span>
                        ))}
                        , {pluralize("delivery", thorEventViewStore.eventDetails.impactedDeliveries.length)}{" "}
                        {thorEventViewStore.eventDetails.impactedDeliveries.map((delivery, index) => (
                            <span className={classes.linkText} key={delivery.deliveryId}>
                                {" "}
                                #{delivery.deliveryNumber}
                                {index !== thorEventViewStore.eventDetails.impactedDeliveries.length - 1 && ","}
                            </span>
                        ))}
                        , {pluralize("handling unit", thorEventViewStore.eventDetails.impactedHandlingUnits.length)}{" "}
                        {thorEventViewStore.eventDetails.impactedHandlingUnits.map((handlingUnit, index) => (
                            <span className={classes.linkText} key={handlingUnit.handlingUnitId}>
                                {" "}
                                #{handlingUnit.handlingUnitNumber}
                                {index !== thorEventViewStore.eventDetails.impactedHandlingUnits.length - 1 && ","}
                            </span>
                        ))}
                        , were impacted by this event.
                    </Typography>
                </ListItem>
            </List>
        </div>
    );
});
